export default __webpack_public_path__ + "static/media/financialRep.48974b60.png";